import { Popover } from "antd";
import React, { useState } from "react";
import Can from "../../../Shared/Can";
import CostForm from "./CostForm";

const CostPopover = (props: any): JSX.Element => {
  const { ticket, onSubmit, children, editable } = props;
  const [visible, setVisible] = useState<boolean>(false);

  return (
    <Popover
      visible={visible}
      onVisibleChange={(change) => setVisible(change)}
      style={{ width: "400px" }}
      placement="top"
      content={
        <CostForm
          onSubmit={onSubmit}
          cost={ticket?.cost}
          pay={ticket?.pay}
          setPopoverVisible={setVisible}
        />
      }
      title="Zmień koszty"
      trigger={editable ? "click" : "disabled"}
      getPopupContainer={(trigger) => trigger.parentElement as HTMLElement}
    >
      {children}
    </Popover>
  );
};

export default CostPopover;
